import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { FileText, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-[#0a0a0f] pt-20 pb-12 px-4" data-testid="terms-page">
      <div className="max-w-4xl mx-auto">
        <Link to="/">
          <Button variant="ghost" className="mb-6 text-gray-400 hover:text-white">
            <ArrowLeft className="h-4 w-4 mr-2" /> Back to Home
          </Button>
        </Link>
        
        <Card className="bg-[#14120f] border-[#1c1814]">
          <CardHeader className="border-b border-[#1c1814]">
            <div className="flex items-center gap-3">
              <FileText className="h-8 w-8 text-[#D4AF37]" />
              <div>
                <CardTitle className="text-2xl text-white">Terms of Service</CardTitle>
                <p className="text-gray-400 text-sm">Last updated: January 2025</p>
              </div>
            </div>
          </CardHeader>
          <CardContent className="pt-6 prose prose-invert max-w-none">
            <div className="space-y-6 text-gray-300">
              <section>
                <h2 className="text-xl font-bold text-white mb-3">1. Acceptance of Terms</h2>
                <p>
                  By accessing or using the Nouveau Riche Legacy platform ("Service"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our Service.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mb-3">2. Description of Service</h2>
                <p>
                  Nouveau Riche Legacy provides an educational platform for financial literacy, including but not limited to:
                </p>
                <ul className="list-disc pl-6 mt-2 space-y-1">
                  <li>Educational courses on trading, investing, and personal finance</li>
                  <li>Paper trading simulation tools</li>
                  <li>Integration with third-party brokers for live trading (via Alpaca)</li>
                  <li>AI-powered financial guidance (educational purposes only)</li>
                  <li>Community features and copy trading functionality</li>
                  <li>E-commerce for merchandise and educational materials</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mb-3">3. User Accounts</h2>
                <p>
                  You are responsible for maintaining the confidentiality of your account credentials. You agree to notify us immediately of any unauthorized use of your account. We are not liable for any loss arising from unauthorized access to your account.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mb-3">4. Educational Purpose</h2>
                <p className="font-semibold text-[#D4AF37]">
                  IMPORTANT: All content on this platform is for educational and informational purposes only. Nothing on this platform constitutes financial, investment, legal, or tax advice.
                </p>
                <p className="mt-2">
                  We do not recommend any specific investments, securities, or trading strategies. Any trading decisions you make are solely your own responsibility.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mb-3">5. Third-Party Integrations</h2>
                <p>
                  Our platform integrates with third-party services including Alpaca for brokerage services. Your use of these services is subject to their respective terms and conditions. We are not responsible for the actions or policies of third-party providers.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mb-3">6. Paper Trading vs. Live Trading</h2>
                <p>
                  Paper trading uses simulated money and does not involve real financial risk. Live trading involves real money and carries significant risk of loss. You acknowledge that:
                </p>
                <ul className="list-disc pl-6 mt-2 space-y-1">
                  <li>Past performance does not guarantee future results</li>
                  <li>You may lose some or all of your invested capital</li>
                  <li>You should only trade with money you can afford to lose</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mb-3">7. Prohibited Activities</h2>
                <p>You agree not to:</p>
                <ul className="list-disc pl-6 mt-2 space-y-1">
                  <li>Use the Service for any illegal purpose</li>
                  <li>Attempt to gain unauthorized access to our systems</li>
                  <li>Share your account with others</li>
                  <li>Misrepresent your identity or qualifications</li>
                  <li>Use automated systems to access the Service without permission</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mb-3">8. Intellectual Property</h2>
                <p>
                  All content, including courses, materials, logos, and software, is owned by Nouveau Riche Legacy or its licensors. You may not reproduce, distribute, or create derivative works without our written consent.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mb-3">9. Limitation of Liability</h2>
                <p>
                  To the maximum extent permitted by law, Nouveau Riche Legacy shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to loss of profits, data, or other intangible losses resulting from your use of the Service.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mb-3">10. Changes to Terms</h2>
                <p>
                  We reserve the right to modify these terms at any time. Continued use of the Service after changes constitutes acceptance of the new terms.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mb-3">11. Contact Information</h2>
                <p>
                  For questions about these Terms, please contact us at: support@nouveaurichelegacy.com
                </p>
              </section>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
